import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn } from "../common.styles";
import { LightText } from "../HXDesktopPage.styles";
export const VideoImageContainer = styled(FlexColumn) `
    width: 100%;
    background: ${colors.black_main};
    align-items: center;
`;
export const VideoImg = styled.img `
    max-width: 100%;
`;
export const VideoProcessingPreviewContainer = styled.div `
    width: 100%;
    background: #00000033;
    border: 1px solid ${colors.black_12};
`;
export const VideoProcessingPreviewWrapper = styled(FlexColumn) `
    justify-content: center;
`;
export const VideoProcessingPreviewText = styled(LightText) `
    text-align: center;
    padding: 10px;
`;
export const VideoPlayerContainer = styled.div `
    & .vjs-tech {
        object-fit: cover;
    }
`;
